angular.module('core')
  .directive("serverValidatedInput", function() {
    return {
      restrict: "A",
      link: function(scope, element, attributes) {
        var watchString = "settings.errors." + attributes.serverValidatedInput + "";
        scope.$watch(watchString, function(newValue, oldValue) {
          if (newValue) {
            var inputElement = scope.settingsForm[attributes.name];
            if (inputElement) {
              inputElement.$setValidity("servererror", false);
              scope.$watch(attributes.ngModel, function(newValue, oldValue) {
                if (oldValue !== newValue) {
                  inputElement.$setValidity("servererror", true);
                }
              });
            }
          }
        });
      }
    };
  });